import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Component as VueComponent } from "vue";
import { DashboardGridSize } from "@/types/Dashboard";
import { MilestoneReportConfig, MilestoneReportFilters } from "@/types/reports/PlotMilestone";
import MilestonePlotDefault from "@/views/reports/plots/milestone/MilestonePlotDefault.vue";
import MilestonePlotProgressCurve from "@/views/reports/plots/milestone/MilestonePlotProgressCurve.vue";

const defaultFullHeight = 600;


export default /*#__PURE__*/_defineComponent({
  __name: 'MilestonePlot',
  props: {
    reportId: {},
    filters: {},
    config: {},
    title: {},
    width: {},
    height: { default: defaultFullHeight },
    spacingX: { default: 0 },
    spacingY: { default: 0 },
    dashboardGridSize: {}
  },
  emits: ["widgetRouteClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const variants: Record<MilestoneReportConfig["variant"], VueComponent> = {
  milestone: MilestonePlotDefault,
  progress_curve: MilestonePlotProgressCurve,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(variants[_ctx.config.variant]), _mergeProps(props, {
    onWidgetRouteClicked: _cache[0] || (_cache[0] = ($event: any) => (emit('widgetRouteClicked')))
  }), null, 16))
}
}

})